import { FC } from 'react';

interface WarningIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const WarningIcon: FC<WarningIconProps> = ({ width = '32', height = '32', color = '#DD524C' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
      <path
        d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM15.9922 21.4111C15.168 21.4113 14.5 22.0826 14.5 22.9102V22.9248C14.5001 23.7523 15.1681 24.4236 15.9922 24.4238H16.0078C16.8319 24.4236 17.4999 23.7523 17.5 22.9248V22.9102C17.5 22.0826 16.832 21.4113 16.0078 21.4111H15.9922ZM15.9922 7.92383C15.1681 7.92402 14.5001 8.59436 14.5 9.42188V16.915C14.5 17.7426 15.168 18.4139 15.9922 18.4141C16.8165 18.4141 17.4854 17.7427 17.4854 16.915V9.42188C17.4853 8.59425 16.8165 7.92383 15.9922 7.92383Z"
        fill={color}
      />
      <defs>
        <linearGradient
          id="paint0_linear_5234_26667"
          x1="38.8357"
          y1="-15.5375"
          x2="60.4021"
          y2="42.4183"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEE13F" />
          <stop offset="0.929667" stopColor="#DD524C" stopOpacity="0.12" />
        </linearGradient>
      </defs>
    </svg>
  );
};
